export default {
    'SearchFormName': 'Search sheet name',
    'QueryTips1': 'Have find results:',
    'QueryTips2': 'items',
    'HistorySearch': 'History Search',
    'PleaseInputKeys': 'Keywords search',
    'RecentlyUsed': 'Recently use',
    'WorkflowCount': '{length} workflow items',
    'OpenFormsTips': 'Webpage Link is empty,please contact with administrator！',
};
